<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Name</th>
          <th>Permissions</th>
          <th>Updated</th>
          <th>Active</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="role in roles" :key="role.id" v-show="true">
          <td><router-link :to="'/admin/role/' + role.id">{{ role.name || '/' }}</router-link></td>
          <td>{{ role.permissions.join(', ') }}</td>
          <td>{{ $moment(role.updated.date).format('DD.MM.YYYY hh:mm') }}</td>
          <td>
            <i v-show="role.active" class="fa fa-check"></i>
            <i v-show=" ! role.active" class="fa fa-remove"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      roles: 'getUserRoles'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Roles/List.vue